import { render, staticRenderFns } from "./ContractText.vue?vue&type=template&id=33fe4efa&scoped=true&"
import script from "./ContractText.vue?vue&type=script&lang=js&"
export * from "./ContractText.vue?vue&type=script&lang=js&"
import style0 from "./ContractText.vue?vue&type=style&index=0&id=33fe4efa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fe4efa",
  null
  
)

export default component.exports